import React, { useMemo } from 'react';
import { ITabsProps, Tabs } from '@jcm/design-system';
import TabMenuObrigacoes from '../../../Obrigacoes/ObrigacoesTabMenu/TabMenuObrigacoes';

type ObrigacoesTabMenuAbrappProps = {
	todasObrigacoes: number;
	excluidas: number;
	activeTabKey: string;
	onTabChange: (tabKey: string) => void;
	loading: boolean;
};

const ObrigacoesTabMenuAbrapp: React.FC<ObrigacoesTabMenuAbrappProps> = (props) => {
	const isDisabled = props.loading;

	const paginas: ITabsProps['items'] = useMemo(
		() => [
			{
				key: 'todasObrigacoes',
				label: (
					<TabMenuObrigacoes
						tituloPagina='Todas Obrigações'
						rotuloContagemObrigações='todos'
						quantidade={props.todasObrigacoes}
					/>
				),
				children: null,
				disabled: isDisabled,
			},
			{
				key: 'excluidas',
				label: (
					<TabMenuObrigacoes
						tituloPagina='Excluídas'
						rotuloContagemObrigações='excluidas'
						quantidade={props.excluidas}
					/>
				),
				children: null,
				disabled: isDisabled,
			},
		],
		[props],
	);

	const handleTabChange = (key: string) => {
		props.onTabChange(key);
	};

	return <Tabs items={paginas} activeKey={props.activeTabKey} onChange={handleTabChange} />;
};

export default ObrigacoesTabMenuAbrapp;
